import { Grid, Switch } from "@mui/material";
import { DataGridPro, GridBooleanCell } from "@mui/x-data-grid-pro";
import { VerticalDivider } from "components/alove/VerticalDivider";
import { NotificationCategory, NotificationSetting, NotificationType } from "models/profile/EndUser";
import { Profile } from "models/profile/Profile";
import React, { useEffect } from "react";
import { getNotifcationsSettings, updateNotificationSetting } from "utils/enduserUtils";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
const MDTypography = require("components/MDTypography/index.js").default;

export const EUNotificationsSettings = ({ profileId = "" }) => {
  const [notifications, setNotifications] = React.useState([] as NotificationSetting[]);
  useEffect(() => {
    if (!profileId) return;
    getNotifcationsSettings(profileId).then((res) => {
      setNotifications(res);
    });
  }, [profileId]);

  const updateSetting = (channel: number, category: number, state: boolean) => {
    const notification = notifications.find((n) => n.channel == channel && n.category == category);
    if (!notification) {
      notifications.push({ channel, category, state });
    } else {
      notification!.state = state;
    }
    setNotifications([...notifications]);
    updateNotificationSetting(profileId, channel, category, state);
  }
  return (
    <DataGridPro
    
      rows={Object.keys(NotificationCategory)
        .filter((category) => !isNaN(Number(category)))
        .map((category) => ({
        category: camelCaseToCapitalizedWords(NotificationCategory[category]),
        id: category,
        ...Object.keys(NotificationType).filter((type) => isNaN(Number(type))).reduce((acc, type) => {
          const notification = notifications.find((n) => n.channel == NotificationType[type] && n.category == Number(category));
          return {
            ...acc,
            [type]: notification?.state
          }
        }, {} as any)
      }))}
      columns={[
        { field: "category", headerName: "Category", flex: 1 },
        ...Object.keys(NotificationType)
          .filter((type) => isNaN(Number(type)))
          .map((type) => ({
            field: type,
            headerName: camelCaseToCapitalizedWords(type),
            editable: true,
            type: "boolean",
            renderCell: (params) => {
              if (params.row[type] === undefined) return null;

              return <GridBooleanCell {...params} />
            }
          } as any))
      ]}
      processRowUpdate={(newRow, oldRow, params) => {
        const changed = Object.keys(newRow).filter((key) => newRow[key] !== oldRow[key]);
        if (changed.length > 0) {
          updateSetting(NotificationType[changed[0]], Number(newRow.id), newRow[changed[0]]);
        }
        return newRow;
      }}
    />
  )
};
